/* global axios */
import ApiClient from './ApiClient';

class LeadFollowUpsAPI extends ApiClient {
  constructor() {
    super('leads', { accountScoped: true, apiVersion: 'v2' });
  }

  urlFor(leadId) {
    return `${this.url}/${leadId}/follow_ups`;
  }

  index(leadId) {
    return axios.get(this.urlFor(leadId));
  }

  apply(leadId, payload) {
    return axios.post(`${this.urlFor(leadId)}/apply`, payload);
  }

  pause(leadId, id, payload = {}) {
    return axios.post(`${this.urlFor(leadId)}/${id}/pause`, payload);
  }

  resume(leadId, id) {
    return axios.post(`${this.urlFor(leadId)}/${id}/resume`);
  }

  cancel(leadId, id, payload = {}) {
    return axios.post(`${this.urlFor(leadId)}/${id}/cancel`, payload);
  }

  switch(leadId, id, payload) {
    return axios.post(`${this.urlFor(leadId)}/${id}/switch`, payload);
  }
}

export default new LeadFollowUpsAPI();
